import NonEditableBlockEditor from '@intercom/embercom-composer/components/non-editable-block-editor';
export default NonEditableBlockEditor;
